"use client";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { Select } from "ui/core/select";

export type QuerySelectOption = {
  label: string;
  value: string;
};

type QuerySelectProps = {
  queryName: string;
  options: QuerySelectOption[];
  defaultLabel?: string;
  className?: string;
};

export const QuerySelect = ({
  queryName,
  options,
  defaultLabel,
  className,
}: QuerySelectProps) => {
  const { updateQuery } = useUpdateQuery();
  const handleChangeQuery = (value: string) => {
    updateQuery({ name: queryName, value });
  };

  const handleClick = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const label = event.currentTarget.value;
    const selectedOption = options.find((opt) => opt.label === label);
    if (selectedOption) {
      handleChangeQuery(selectedOption.value);
    }
  };

  return (
    <Select
      options={options.map((opt) => opt.label)}
      onChange={handleClick}
      defaultValue={defaultLabel}
      className={className}
    />
  );
};
